import type { Brand } from 'valibot'

const LEGAL_CONSENT_FIELD_PREFIX = 'LEGAL_CONSENT.subscription_type_'

type SubscriptionTypeIdField = Brand<'SubscriptionTypeIdField'> & string

export const subscriptionTypeUtils = {
  isSubscriptionTypeField: (fieldName: string): fieldName is SubscriptionTypeIdField => fieldName.startsWith(LEGAL_CONSENT_FIELD_PREFIX),
  createFieldName: (subscriptionTypeId: number): SubscriptionTypeIdField => [LEGAL_CONSENT_FIELD_PREFIX, subscriptionTypeId].join('') as SubscriptionTypeIdField,
  getSubscriptionTypeId: (fieldName: SubscriptionTypeIdField) => Number(fieldName.replace(LEGAL_CONSENT_FIELD_PREFIX, '')),
}
